module.exports = __webpack_public_path__ + "static/img/mando-pr.0cb2ee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/mando-pr.jpg
// module id = P2b9
// module chunks = 0